/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_Motion_StoppedInputs */

const vi_fleet_motion_stopped = /** @type {(inputs: Fleet_Motion_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang dừng`)
};

/**

* @param {Fleet_Motion_StoppedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_motion_stopped = /** @type {((inputs?: Fleet_Motion_StoppedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Motion_StoppedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_motion_stopped(inputs)
});